/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { tableStateSchema } from "./tableStateSchema.ts";

export const tableSectionStateSchema = z.object({
	id: z.uuid().nullable(),
	name: z.string(),
	schema: z.any().nullable(),
	tables_count: z.int(),
	free_count: z.int(),
	seats_total: z.int().describe("Сумма вместимости столов зала; 0 — вместимость не заполнена"),
	tables: z.array(tableStateSchema),
});
